export default __webpack_public_path__ + "static/form-input-masks-do-97cf8f4b1d897a613ab5ac8c1789b064.png";